import React from 'react';
import { AppointmentBookingSteps } from '../AppointmentBookingSpec';

interface StepsProps {
  step: AppointmentBookingSteps;
}

const Steps: React.FC<StepsProps> = ({ step }) => {
  const getStepNumber = () => {
    switch (step) {
      case AppointmentBookingSteps.CHOOSE_LOCATION:
        return 1;
      case AppointmentBookingSteps.CHOOSE_SERVICES:
        return 2;
      case AppointmentBookingSteps.SELECT_THE_PROFESSIONAL:
        return 3;
      case AppointmentBookingSteps.CHOOSE_DATE:
        return 4;
      case AppointmentBookingSteps.CHOOSE_PAYMENT_OPTION:
        return 5;
      default:
        return 1;
    }
  };

  return (
    <div
      style={{ display: 'flex', gap: 4, marginTop: 16, marginBottom: 24, justifyContent: 'center' }}
    >
      {[1, 2, 3, 4, 5].map(stepNumber => (
        <div
          key={stepNumber}
          style={{
            width: 65.6,
            height: 6,
            backgroundColor: stepNumber <= getStepNumber() ? '#18617C' : '#0000001A',
            borderRadius: 100,
          }}
        />
      ))}
    </div>
  );
};

export default Steps;
